import React, { Component } from 'react';
import {
  withRouter,
} from 'react-router-dom';

import {
  Typography,
} from '@material-ui/core';
import FilterPanel from './filterPanel';
import FilterList from './FilterList';

import classes from '../../css/getCSS';


class SearchLeftPanel extends Component {
  state = {
    sortPanel: false,
    agePanel: true,
    heightPanel: true,
    maritalPanel: true,
    castePanel: true,
    professionPanel: false,
    workProfilePanel: false,
    qualificationPanel: false,
    studyFieldPanel: false,
    degreePanel: false,
    incomePanel: false,
    countryPanel: false,
    sitePanel: false,
    helpDialog: false,
    fromIndiaPanel: false,
    cityPanel: false,
    bureauPanel: false,
    isPremiumPanel: false,
  }

  handleChange = (panel) => {
    this.setState({
      [panel]: !this.state[panel],
    });
  }

  render() {
    const sortList = [
      { value: 'last-login', display_value: 'Last Login' },
      { value: 'newest-first', display_value: 'Newest First' },
      { value: 'oldest-first', display_value: 'Oldest First' },
    ];

    return (
      <React.Fragment>
        <Typography style={{ padding: '10px 5px' }} variant="headline" className={classes.padding10XS}>Refine your search</Typography>

        <FilterPanel expanded={this.state.sortPanel} panel="sortPanel" title="Sort" handleChange={this.handleChange}>
          <FilterList selectSingle={this.props.selectSingle} list={sortList} facet="sort" />
        </FilterPanel>

        <FilterPanel expanded={this.state.agePanel} panel="agePanel" title="Age" handleChange={this.handleChange}>
          <FilterList selectSingle={this.props.selectSingle} facet="age" activeFilters={this.props.activeFilters} />
        </FilterPanel>

        <FilterPanel expanded={this.state.heightPanel} panel="heightPanel" title="Height" handleChange={this.handleChange}>
          <FilterList selectSingle={this.props.selectSingle} facet="height" activeFilters={this.props.activeFilters} />
        </FilterPanel>

        <FilterPanel expanded={this.state.maritalPanel} panel="maritalPanel" title="Marital Status" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.marital_status} facet="marital_status" />
        </FilterPanel>

        <FilterPanel expanded={this.state.castePanel} panel="castePanel" title="Caste" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.caste} facet="caste" />
        </FilterPanel>

        <FilterPanel expanded={this.state.professionPanel} panel="professionPanel" title="Profession" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.profession} facet="profession" />
        </FilterPanel>

        <FilterPanel expanded={this.state.workProfilePanel} panel="workProfilePanel" title="Work Profile" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.work_profile} facet="work_profile" />
        </FilterPanel>

        <FilterPanel expanded={this.state.qualificationPanel} panel="qualificationPanel" title="Qualification" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.qualification} facet="qualification" />
        </FilterPanel>

        <FilterPanel expanded={this.state.studyFieldPanel} panel="studyFieldPanel" title="Study Field" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.study_field} facet="study_field" />
        </FilterPanel>

        <FilterPanel expanded={this.state.degreePanel} panel="degreePanel" title="Degree" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.degree} facet="degree" />
        </FilterPanel>

        <FilterPanel expanded={this.state.fromIndiaPanel} panel="fromIndiaPanel" title="Candidates living in India?" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.from_india} facet="from_india" />
        </FilterPanel>

        <FilterPanel expanded={this.state.countryPanel} panel="countryPanel" title="Country" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.country} facet="country" type="multiple" />
        </FilterPanel>

        <FilterPanel expanded={this.state.cityPanel} panel="cityPanel" title="City" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.city} facet="city" type="multiple" />
        </FilterPanel>

        <FilterPanel expanded={this.state.bureauPanel} panel="bureauPanel" title="Bureau" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.bureau} facet="bureau" type="multiple" />
        </FilterPanel>

        <FilterPanel expanded={this.state.incomePanel} panel="incomePanel" title="Income" handleChange={this.handleChange}>
          <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.income} facet="income" type="multiple" />
        </FilterPanel>

        {this.props.user.is_premium
         && (
         <FilterPanel expanded={this.state.isPremiumPanel} panel="isPremiumPanel" title="Show Gor Maharaj (premium) profiles" handleChange={this.handleChange}>
           <FilterList selectMultiple={this.props.selectMultiple} list={this.props.facets.is_premium} facet="is_premium" type="multiple" />
         </FilterPanel>
         )}

      </React.Fragment>
    );
  }
}

export default withRouter(SearchLeftPanel);



// WEBPACK FOOTER //
// ./src/search/components/SearchLeftPanel.js